import { ChevronDown, Loader2 } from 'lucide-react';

import type { CandidateStageQuery } from '@/modules/hiring-manager/hooks/useCandidatePipelineQuery';

interface ShowMoreCandidatesProps {
  stageQuery: CandidateStageQuery;
}

/**
 * The next page of a stage, as a quiet line at the end of its group: how
 * many are left, and how many of the stage are showing.
 */
export function ShowMoreCandidates({ stageQuery }: ShowMoreCandidatesProps) {
  if (!stageQuery.hasNextPage) return null;
  const loaded = stageQuery.candidates?.length ?? 0;
  const total = stageQuery.totalCount;
  const Icon = stageQuery.isFetchingNextPage ? Loader2 : ChevronDown;
  return (
    <div className="flex items-center gap-1.5 text-xs">
      <button
        className="text-primary focus-visible:ring-ring/50 inline-flex cursor-pointer items-center gap-1.5 rounded-sm font-medium outline-none hover:underline focus-visible:ring-[3px] disabled:cursor-default"
        disabled={stageQuery.isFetchingNextPage}
        onClick={stageQuery.loadMore}
        type="button"
      >
        <Icon
          aria-hidden
          className={
            stageQuery.isFetchingNextPage ? 'size-3.5 animate-spin' : 'size-3.5'
          }
        />
        {total === undefined ? 'Show more' : `Show ${total - loaded} more`}
      </button>
      {total !== undefined && (
        <span className="text-neutral-500 tabular-nums">
          · showing {loaded} of {total}
        </span>
      )}
    </div>
  );
}
